import React from 'react';
import { COELAreasType } from 'src/shared/types/src';
import { IoCaretDownSharp, IoCaretForwardSharp } from "react-icons/io5";
import { MdCheck} from "react-icons/md";
import TextRenderer from 'src/app/components/commonComponents/TextRenderer';

type COELPropTypes = {
    data: COELAreasType[]
    title: string,
    currTabDetailsShown: Array<string>,
    onPressTab: Function
}

const COEL: React.FC<COELPropTypes> = ({ title, data = [], currTabDetailsShown = [], onPressTab = () => { } }) => {

    const renderCOELFrameworks = (el: any, index: number) => {
        return (
            <div className='mg-t-15'>
                <p className='fs-12 fw-semibold text-black mg-b-0'>{el?.name || ''}</p>
                {el?.value && <p className='fs-12 text-black mg-b-0 mg-t-5'>{el?.value || ''}</p> }

                {el?.aspects.map((aspect: any) => {
                    return (
                        <div className='mg-t-15 d-flex'>
                            {aspect?.value ? <div className='checked-circle mg-r-5 rounded-circle bg-gray-200 d-flex align-items-center justify-content-center'><MdCheck size={12} /></div> : <div className='checked-circle mg-r-5 rounded-circle border border-gray-900'></div>}
                            <div className='fs-12 text-black mg-b-0 flex-1'><TextRenderer text={aspect?.name || ''} /></div>
                        </div>
                    )
                })}
            </div>
        )
    }

    return (
        <>
            <div className='cursor-pointer' onClick={() => {
                if (currTabDetailsShown.includes(title)) {
                    const filteredVisible = currTabDetailsShown.filter((item) => item !== title);
                    onPressTab(filteredVisible)
                } else {
                    onPressTab([...currTabDetailsShown, title])
                }
            }}>
                
                <div className="d-flex align-items-center cursor-pointer">
                    <div className='visible-in-print-view'><IoCaretDownSharp size={15} /></div>
                    <div className='print-element-hide'>{currTabDetailsShown.includes(title) ? <IoCaretDownSharp size={15} /> : <IoCaretForwardSharp size={15} /> }</div>
                    <div className='fs-14 fw-semibold text-black mg-l-10 flex-1'>
                        Characteristics of Effective Learning:
                    </div>
                </div>
            </div>

            <div className='visible-in-print-view'>
                <div className="pd-l-33">
                    {data.map((el, index) => {
                        return renderCOELFrameworks(el, index)
                    })}
                </div>
            </div>
            <div className='print-element-hide'>{currTabDetailsShown.includes(title) && (
                <div className="pd-l-33">
                    {data.map((el, index) => {
                        return renderCOELFrameworks(el, index)
                    })}
                </div>
            )}</div>
        </>
    )
};

export default COEL